import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { projectsData, getCategoryColor } from '../data/projects';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import './ProjectsPage.css';
// Reuse card styles from Projects component
import '../components/Projects/Projects.css';

const CATEGORIES = ['Todos', 'Supervisión de Obra', 'Infraestructura Civil', 'Edificaciones', 'Proyectos Corporativos', 'Remodelaciones y Adecuaciones', 'Diseño e Ingeniería'];

const ProjectsPage = () => {
  const [searchParams] = useSearchParams();
  const [activeFilter, setActiveFilter] = useState(() => {
    const cat = searchParams.get('categoria');
    return cat && CATEGORIES.includes(cat) ? cat : 'Todos';
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const filtered =
    activeFilter === 'Todos'
      ? projectsData
      : projectsData.filter((p) => p.category === activeFilter);

  return (
    <div className="projects-page">
      <Navbar />

      {/* Hero */}
      <div className="projects-page__hero">
        <div className="projects-page__hero-bg" />
        <div className="container projects-page__hero-content">
          <span className="section-label">Portafolio completo</span>
          <h1 className="projects-page__heading">
            Nuestros <em>proyectos.</em>
          </h1>
          <p className="projects-page__sub">
            Cada obra es un compromiso con la excelencia. Explore nuestro 
            historial de proyectos residenciales, comerciales e infraestructura 
            en toda Honduras.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="container">
        {/* Filters */}
        <div className="projects-page__filters">
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              className={`filter-btn ${activeFilter === cat ? 'filter-btn--active' : ''}`}
              onClick={() => setActiveFilter(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        <p className="projects-page__count">
          Mostrando <span>{filtered.length}</span> proyecto{filtered.length !== 1 ? 's' : ''}
          {activeFilter !== 'Todos' && <> — <span>{activeFilter}</span></>}
        </p>

        {/* Grid — reuse ProjectCard styles */}
        <div className="projects-page__grid">
          {filtered.length === 0 && (
            <div className="projects-page__empty">
              No hay proyectos en esta categoría aún.
            </div>
          )}
          {filtered.map((project) => {
            const categoryColor = getCategoryColor(project.category);
            const isCompleted = project.status === 'Completado';
            return (
              <div key={project.id} className="project-card">
                <Link to={`/proyectos/${project.id}`} className="project-card__image-wrap">
                  <img
                    src={project.coverImage}
                    alt={project.title}
                    className="project-card__image"
                    loading="lazy"
                  />
                  <div className="project-card__overlay" />
                  <span
                    className="project-card__category-badge"
                    style={{ background: categoryColor }}
                  >
                    {project.category}
                  </span>
                  <span
                    className={`project-card__status ${
                      isCompleted
                        ? 'project-card__status--completed'
                        : 'project-card__status--in-process'
                    }`}
                  >
                    {isCompleted ? '✓ Completado' : '◐ En proceso'}
                  </span>
                </Link>

                <div className="project-card__body">
                  <h3 className="project-card__title">{project.title}</h3>
                  <div className="project-card__meta">
                    <span className="project-card__meta-item">
                      📍 {project.location.split(',')[0]}
                    </span>
                    {!project.hideTechSheet && (
                      <>
                        <span className="project-card__meta-dot" />
                        <span className="project-card__meta-item">
                          📐 {project.area}
                        </span>
                        <span className="project-card__meta-dot" />
                        <span className="project-card__meta-item">
                          📅 {project.year}
                        </span>
                      </>
                    )}
                  </div>
                  <p className="project-card__desc">{project.shortDescription}</p>
                </div>

                <div className="project-card__footer">
                  <Link to={`/proyectos/${project.id}`} className="project-card__btn">
                    Ver más
                    <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M3 8H13M13 8L8 3M13 8L8 13"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ProjectsPage;
